// src/pages/AppPage.tsx
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { RootState } from 'store';
import { useSocket } from 'hooks/useSocket';
import Header from 'components/layout/Header';
import Sidebar from 'components/layout/Sidebar';
import OnlineBar from 'components/layout/OnlineBar';
import PomodoroBar from 'components/layout/PomodoroBar';
import ReviewRequestPopup from 'components/layout/ReviewRequestPopup';

export default function AppPage() {
  const { sidebarOpen } = useSelector((s: RootState) => s.ui);
  useSocket(); // Connect Socket.io

  return (
    <div className="flex flex-col h-screen overflow-hidden bg-[var(--om-app)] text-[var(--om-text)] font-sans">
      <Header />
      <OnlineBar />
      <PomodoroBar />

      <div className="flex flex-1 overflow-hidden min-h-0">
        {/* Sidebar */}
        <aside
          className={`transition-all duration-200 overflow-hidden flex-shrink-0 bg-[var(--om-panel)] border-r border-[var(--om-border)] ${
            sidebarOpen ? 'w-64' : 'w-0'
          }`}
        >
          <Sidebar />
        </aside>

        {/* Main view */}
        <main className="flex-1 overflow-hidden min-h-0 flex flex-col">
          <Outlet />
        </main>
      </div>

      <ReviewRequestPopup />
    </div>
  );
}
